const coursetypes = {
	title: "Course Types",
	short_title: "Type",
	new_coursetype: "New Course Type",
	edit_coursetype: "Edit: {name}",
	view_coursetype: "View: {name}",
	list_title: "List of Course Types",
	list_subtitle: "Manage Course Types",
	create_title: "Create New Course Type",
	update_title: "Update Course Type",
	details_title: "Course Type Details",
	id: "ID",
	name: "Name",
	category: "Category",
	status: "Status",
	code: "Code",
	teaching_plan: "Teaching Plan",
	teaching_material: "Teaching Materials",
	register_interest: "Used to register interest",
	register_interest_short: "Interest reg.",
	register_interest_helptext: "Keep this checked if you would like people to be able to register interest for this course type from the course list.",
};
export default coursetypes;